/* eslint-disable camelcase, no-undef */
// Runtime override for lazy-chunk publicPath.
// - Local hosts must always use "/" so chunks load from artisan serve, not CDN.
// - Production may set window.__MIX_ASSET_URL__ (or bake ASSET_URL) for CloudFront.
(function () {
  var host =
    typeof window !== 'undefined' && window.location ? String(window.location.hostname || '') : '';
  var isLocal = host === 'localhost' || host === '127.0.0.1' || host === '[::1]';

  if (isLocal) {
    __webpack_public_path__ = '/';
    return;
  }

  var fromWindow =
    typeof window !== 'undefined' && window.__MIX_ASSET_URL__
      ? String(window.__MIX_ASSET_URL__)
      : '';
  var fromEnv = '';
  if (typeof process !== 'undefined' && process.env) {
    fromEnv = String(process.env.MIX_ASSET_URL || process.env.ASSET_URL || '');
  }

  var next = (fromWindow || fromEnv).trim();
  if (!next || next === '/') {
    return;
  }

  __webpack_public_path__ = next.replace(/\/?$/, '/');
})();
